export default (input: string) => input.replace(/\D/g, "");
